var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5C0 2.01472 2.01472 0 4.5 0H31.5C33.9853 0 36 2.01472 36 4.5V31.5C36 33.9853 33.9853 36 31.5 36H4.5C2.01472 36 0 33.9853 0 31.5V4.5Z",
    fill: "#E81717"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5905_532917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5905_532917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9585 24.5736C8.71058 24.5736 8.50282 24.4897 8.3352 24.3219C8.1674 24.1542 8.0835 23.9464 8.0835 23.6983C8.0835 23.4504 8.1674 23.2426 8.3352 23.075C8.50282 22.9076 8.71058 22.8239 8.9585 22.8239H27.0418C27.2897 22.8239 27.4975 22.9077 27.6651 23.0753C27.8329 23.2431 27.9168 23.451 27.9168 23.6991C27.9168 23.9471 27.8329 24.1548 27.6651 24.3224C27.4975 24.4899 27.2897 24.5736 27.0418 24.5736H8.9585ZM8.9585 18.875C8.71058 18.875 8.50282 18.7911 8.3352 18.6233C8.1674 18.4555 8.0835 18.2476 8.0835 17.9997C8.0835 17.7516 8.1674 17.5438 8.3352 17.3764C8.50282 17.2088 8.71058 17.125 8.9585 17.125H27.0418C27.2897 17.125 27.4975 17.2089 27.6651 17.3767C27.8329 17.5445 27.9168 17.7524 27.9168 18.0003C27.9168 18.2484 27.8329 18.4561 27.6651 18.6236C27.4975 18.7912 27.2897 18.875 27.0418 18.875H8.9585ZM8.9585 13.1761C8.71058 13.1761 8.50282 13.0923 8.3352 12.9247C8.1674 12.7569 8.0835 12.5489 8.0835 12.3008C8.0835 12.0529 8.1674 11.8451 8.3352 11.6775C8.50282 11.5101 8.71058 11.4264 8.9585 11.4264H27.0418C27.2897 11.4264 27.4975 11.5103 27.6651 11.6781C27.8329 11.8457 27.9168 12.0536 27.9168 12.3017C27.9168 12.5496 27.8329 12.7574 27.6651 12.925C27.4975 13.0924 27.2897 13.1761 27.0418 13.1761H8.9585Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDefault);
export default __webpack_public_path__ + "static/media/menu-default.2d8f0ea622aac3b06e8c3a9fd3ec0b90.svg";
export { ForwardRef as ReactComponent };